/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const IconBox = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${theme.spacing.spacing01} ${theme.spacing.spacing02} 0 0;
`;

export const CostWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${theme.spacing.spacing01} 0;
`;
